
export abstract class Plugin {

    protected static initialize() {
        if (!window.rainbow) { window.rainbow.plugins = {}; }
    }

    protected constructor() { }
}

export interface SDKPlugin {
    initialize(): void;
}
